import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/features/auth/AuthProvider';
import { CHAT_ACAO } from './chatAcoes';
import { chatService } from './chatService';

export const chatKeys = {
  all: ['chat'] as const,
  conversas: () => [...chatKeys.all, 'conversas'] as const,
  resumo: () => [...chatKeys.all, 'resumo'] as const,
  conversa: (id: number) => [...chatKeys.all, 'conversa', id] as const,
  responsavel: (id: number) => [...chatKeys.all, 'responsavel', id] as const,
  mensagens: (id: number) => [...chatKeys.all, 'mensagens', id] as const,
  midias: (id: number) => [...chatKeys.all, 'midias', id] as const,
};

export function useChatResumo(pollingAtivo: boolean) {
  const { user } = useAuth();
  const enabled = Boolean(user?.acoes.includes(CHAT_ACAO.VER) && user.idEscolaAtiva != null);

  return useQuery({
    queryKey: [...chatKeys.resumo(), user?.idEscolaAtiva],
    queryFn: () => chatService.obterResumo(),
    enabled,
    staleTime: 15_000,
    refetchInterval: pollingAtivo ? 15_000 : false,
    refetchOnWindowFocus: true,
  });
}

export function useChatConversas(socketDown: boolean, busca?: string) {
  const { user } = useAuth();
  const enabled = Boolean(user?.acoes.includes(CHAT_ACAO.VER) && user.idEscolaAtiva != null);
  const buscaEfetiva =
    busca && busca.trim().length >= 2 ? busca.trim() : undefined;

  return useQuery({
    queryKey: [...chatKeys.conversas(), user?.idEscolaAtiva, buscaEfetiva ?? ''],
    queryFn: () => chatService.listarConversas(buscaEfetiva),
    enabled,
    staleTime: 10_000,
    refetchInterval: socketDown ? 15_000 : false,
  });
}

export function useInvalidateChat() {
  const queryClient = useQueryClient();
  return () => {
    void queryClient.invalidateQueries({ queryKey: chatKeys.all });
  };
}
